<template>
    <b-form id="search" @submit="onSubmit">
        <b-row class="no-gutters">
            <b-col lg="4" md="12">
                <LocationSearch v-model="search.place" :value="search.place"/>
            </b-col>
            <b-col lg="4" md="12">
                <DatePicker v-model="search.date" :value="search.date"/>
            </b-col>
            <b-col lg="2" md="12">
                <OccupationPicker v-model="search.occupation" :value="search.occupation" />
            </b-col>
            <b-col lg="2" md="12">
                <b-button variant="primary" type="submit" class="btn-block search-button">
                    Search
                </b-button>
            </b-col>
        </b-row>
    </b-form>
</template>

<script>
    import LocationSearch from '@/components/ui/LocationSearch.vue'
    import OccupationPicker from '@/components/ui/OccupationPicker.vue'
    import DatePicker from '@/components/ui/DatePicker.vue'

    export default {
        name: 'Search',
        props: {
            search: {
                type: Object,
                required: true
            }
        },
        components: {
            LocationSearch,
            OccupationPicker,
            DatePicker,
        },
        methods: {
            onSubmit: async function (e) {
                e.preventDefault();

                this.$router.push({
                    path: `/${this.$route.params.locale}/hotels/`, query: {
                        search: this.search.place.name,
                        lat: this.search.place.lat,
                        lng: this.search.place.lng,
                        checkin: this.search.date.checkin,
                        checkout: this.search.date.checkout,
                        adults: this.search.occupation.adults,
                        children: this.search.occupation.children,
                        rooms: this.search.occupation.rooms,
                        ages: JSON.stringify(this.search.occupation.ages),
                        sort: this.search.sort,
                        page: this.search.page,
                    }
                });

                this.$emit("update-search", this.search);
            }
        }
    }
</script>

<style scoped>
    @media screen and (min-width:991px) {
        .search-button{
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }
</style>